<template>
	<div>
		<div class="row">
			<div class="col-lg-3">
				<label for="">Fecha *</label>
                <v-date-picker v-model="VehiculoStock.Fecha" :mode="typeCalendar"
					:popover="{
						placement: 'bottom',
						visibility: 'click'
					}"
					:input-props="{
						class: 'form-control cal-black',
						style: 'cursor:pointer;'
					}"
                    :locale="'es-MX'"
				/>
			</div>
			<div class="col-lg-6">
				<label for="">Refacción</label>
				<treeselect
					:maxHeight="180"
					:options="ListRefacciones"
					placeholder="Refacción"
					v-model="VehiculoStock.IdRefaccion"
					:disable-fuzzy-matching="true"
				/>
			</div>
			<div class="col-lg-2">
				<label>Cantidad *</label>
				<vue-numeric
					class="form-control"
					separator=","
					placeholder="0"
					:precision="0"
					v-model="VehiculoStock.Cantidad"
				></vue-numeric>
			</div>
		</div>
		<div class="row mt-3">
			<div class="col-lg-3">
				<label>Valor *</label>
				<vue-numeric
					class="form-control "
					currency="$"
					separator=","
					placeholder="$0"
					:precision="0"
					v-model="VehiculoStock.Valor"
				></vue-numeric>
			</div>
			<div class="col-lg-3">
				<label for="">Fecha de Revisión *</label>
                <v-date-picker v-model="VehiculoStock.FechaRevision" :mode="typeCalendar"
					:popover="{
						placement: 'bottom',
						visibility: 'click'
					}"
					:input-props="{
						class: 'form-control cal-black',
						style: 'cursor:pointer;'
					}"
                    :locale="'es-MX'"
				/>
			</div>
		</div>
		<div class="row mt-3">
			<div class="col-lg-12">
				<label for="">Observaciones</label>
				<textarea class="form-control" v-model="VehiculoStock.Observaciones" cols="10" rows="4"></textarea>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name:"Stock",
    props:["poBtnSave","pIdVehiculo"],
	data() {
        return {
            Modal:true,
            FormName:'Stock',
            EmitSeccion:this.poBtnSave.EmitSeccion,
            VehiculoStock:{
                IdVehiculoStock:0,
                IdVehiculo:0,
				IdRefaccion:null,
                Fecha:'',
				FechaRevision:'',
				Cantidad:0,
				Valor:0,
                Observaciones:'',
            },
            errorvalidacion:[],
			ListRefacciones:[],
			ListRefaccionesCompleta:[]
        }
    },
	methods: {
		Guardar(){
            let Fecha='';
            if (this.VehiculoStock.Fecha!='' && this.VehiculoStock.Fecha!=undefined) {
                let day=this.VehiculoStock.Fecha.getDate();
                let month=this.VehiculoStock.Fecha.getMonth()+1;
                let year=this.VehiculoStock.Fecha.getFullYear();
                Fecha=year+'-'+month+'-'+day;   
            }
			let FechaRevision='';
            if (this.VehiculoStock.FechaRevision!='' && this.VehiculoStock.FechaRevision!=undefined) {
                let day=this.VehiculoStock.FechaRevision.getDate();
                let month=this.VehiculoStock.FechaRevision.getMonth()+1;
                let year=this.VehiculoStock.FechaRevision.getFullYear();
                FechaRevision=year+'-'+month+'-'+day;   
            }
            let formData=new FormData();
            formData.set('IdVehiculoStock',this.VehiculoStock.IdVehiculoStock);
            formData.set('IdVehiculo',this.VehiculoStock.IdVehiculo);
			formData.set('IdRefaccion',this.VehiculoStock.IdRefaccion);
            formData.set('Valor',this.VehiculoStock.Valor);
			formData.set('Cantidad',this.VehiculoStock.Cantidad);
            formData.set('Observaciones',this.VehiculoStock.Observaciones);
            formData.set('Fecha',Fecha);
			formData.set('FechaRevision',FechaRevision);
            this.poBtnSave.toast=0;
            this.poBtnSave.disableBtn=true;
            this.$http.post('vehiculostock/post',formData).then((res)=>{
                this.poBtnSave.disableBtn=false; 
                this.poBtnSave.toast=1;
                $("#Stock").modal("hide");
                this.bus.$emit('ListaPrincipal');
            }).catch((err)=>{
                this.errorvalidacion=err.response.data.message.errores;
                this.poBtnSave.disableBtn=false;
                this.poBtnSave.toast=2;
            });
        },
		Limpiar(){
            this.VehiculoStock={
                IdVehiculoStock:0,
                IdVehiculo:0,
				IdRefaccion:null,
                Fecha:new Date(),
				FechaRevision:new Date(),
				Cantidad:0,
				Valor:0,
                Observaciones:'',
            }
        },
		Recuperar(){
            this.$http.get('vehiculostock/recovery',{
                params:{
                    IdVehiculoStock:this.VehiculoStock.IdVehiculoStock
                }
            }).then((res)=>{
                const objres=res.data.data.vehiculostock;
                this.VehiculoStock.IdVehiculoStock=objres.IdVehiculoStock;
                this.VehiculoStock.IdVehiculo=objres.IdVehiculo;
				this.VehiculoStock.IdRefaccion=objres.IdRefaccion==0 ? null : objres.IdRefaccion;
                this.VehiculoStock.Valor=objres.Valor;
				this.VehiculoStock.Cantidad=objres.Cantidad;
                this.VehiculoStock.Observaciones=objres.Observaciones;
                let formatedDate = objres.Fecha.replace(/-/g, "\/");
                this.VehiculoStock.Fecha=new Date(formatedDate);
				let formatedDate2 = objres.FechaRevision.replace(/-/g, "\/");
                this.VehiculoStock.FechaRevision=new Date(formatedDate2);
            })
        },
		GetRefacciones(){
			this.$http.get('refacciones/get').then((res)=>{
				this.ListRefaccionesCompleta=res.data.data.todos;
				this.ListRefacciones=res.data.data.todos.map((value) => {
					return {
						id:value.IdRefaccion,
						label:value.Item+' '+value.Marca+' '+value.Modelo
					}
				});
			});
		}
	},
	created() {
		this.bus.$off("NewModal_"+this.EmitSeccion);
        this.bus.$on("NewModal_"+this.EmitSeccion,(data,Id,IdVehiculo)=>{
            this.poBtnSave.disableBtn=false;
            this.bus.$off("Save_"+this.EmitSeccion);
            this.bus.$on("Save_"+this.EmitSeccion, () => {
				this.Guardar();
			});
            this.Limpiar();
            if (IdVehiculo!==undefined) {
                this.VehiculoStock.IdVehiculo=IdVehiculo;
            }
            if (Id > 0) {
				this.VehiculoStock.IdVehiculoStock = Id;
				this.Recuperar();
			}
			this.GetRefacciones();
        });
	},
	computed:{
        typeCalendar:function(){
            return 'single';
        }
    }
}
</script>

<style>

</style>
